// Lightweight stub for site routes that aren't built yet (Events Calendar,
// Watch Live, Shop, Get a Quote). Each shows a placeholder + back-to-home link
// so nav items resolve and don't 404. Each will get its own dedicated page in
// future sessions.
import SiteNav from "./components/SiteNav";

export default function StubPage({ title, blurb, comingSoon = true }) {
  return (
    <div style={{ background: "#0e2e46", minHeight: "100vh", color: "var(--jop-cream)" }}>
      <SiteNav />
      <section style={{
        minHeight: "calc(100vh - 4rem)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "5rem 1.5rem",
        textAlign: "center",
      }}>
        <h1 style={{
          margin: "0 0 1rem",
          fontFamily: "var(--jop-script)",
          fontSize: "clamp(2.4rem, 6vw, 4rem)",
          color: "var(--jop-gold)",
          fontWeight: 700,
        }}>
          {title}
        </h1>
        <p style={{
          maxWidth: "520px",
          fontFamily: "var(--jop-display)",
          fontSize: "1.05rem",
          lineHeight: 1.6,
          color: "rgba(255,218,173,0.85)",
          margin: "0 0 2rem",
        }}>
          {blurb}
        </p>
        {comingSoon && (
          <div style={{
            display: "inline-block",
            padding: "0.4rem 0.85rem",
            border: "1px dashed rgba(252,179,31,0.45)",
            borderRadius: "999px",
            color: "var(--jop-gold)",
            fontFamily: "var(--jop-display)",
            fontSize: "0.78rem",
            fontWeight: 700,
            letterSpacing: "0.08em",
            marginBottom: "2rem",
          }}>
            COMING SOON
          </div>
        )}
        <a
          href="/"
          style={{
            color: "var(--jop-highlight-blue)",
            fontFamily: "var(--jop-display)",
            fontWeight: 600,
            textDecoration: "none",
            fontSize: "0.95rem",
          }}
        >
          ← Back to Home
        </a>
      </section>
    </div>
  );
}
